import React from 'react'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import { withStyles } from '@material-ui/core/styles'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton
} from '@material-ui/core'
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons'
import Checkbox from '@material-ui/core/Checkbox'
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank'
import CheckBoxIcon from '@material-ui/icons/CheckBox'
import { Translation } from 'react-i18next'
import {
  convertIntToState_ws,
  rearrangeByPinned
} from '../../utils/openForWork.utils'
import { Table, TableHead, TableBody } from '@material-ui/core'
import moment from 'moment/moment'
import { formatTime } from '../../utils/openForWork.utils'
import WorkShiftDetails from './workshiftDetails.component'
import PushPinIcon from '@mui/icons-material/PushPin'
import { CloseIcon } from './closeIcon.component'
import {
  defaultValues as invoiceFormValues,
  invoiceRowDefaultValues
} from '../invoice/invoiceForm.component'
import { convertIntToState, invoiceValues } from '../../utils/invoice.utils'
import { Link } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { showInvoiceFormDialog } from '../../actions'

/**
 *
 * @author Huong Nguyen
 */

const styles = (theme) => ({
  tablecell: {
    fontSize: '12px',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1.5),
    verticalAlign: 'top',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    whiteSpace: 'normal',
    maxWidth: '250px'
  },
  text: {
    width: '200px',
    wordWrap: 'break-word',
    overflowWrap: 'break-word',
    whiteSpace: 'normal'
  },
  previewLabel: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#808080'
  },
  previewValue: {
    fontWeight: 500
  },
  textField2: {
    marginTop: theme.spacing(4),
    border: '1px solid gray',
    fontSize: '14px'
  }
})

const WorkshiftUserRow = ({
  classes,
  data = [],
  index,
  employer_name,
  updateUserWorkshift,
  updateViewWorkshift,
  pinWorkShift,
  saveInvoiceDraft,
  editInvoice,
  saveDraftInvoiceSuccess,
  getBillableHourUser,
  selectedCheckbox,
  handleSelectCheckbox,
  selectedAllCheckbox
}) => {
  const [expand, setExpand] = React.useState(false)
  const [selectedWorkshift, setSelectedWorkshift] = React.useState(null)
  const invoice_id = selectedWorkshift?.invoice_id ?? null

  const handleExpandClick = () => {
    setExpand((prevExpand) => !prevExpand)
  }

  const dispatch = useDispatch()
  const handleEditInvoice = (id) => {
    dispatch(showInvoiceFormDialog())
    dispatch(editInvoice(id))
  }
  const [showAcceptWarn, setShowAcceptWarn] = React.useState(false)
  const disableBtn =
    selectedWorkshift?.workshift_status_entrepreneur !== 0 ? true : false
  const workshiftRows = rearrangeByPinned(
    data?.workshifts,
    'pinned_workshift_user'
  )
  const totalNewWorkshifts = workshiftRows.filter(
    (ws) =>
      ws.is_workshift_viewed === 0 && ws.workshift_status_entrepreneur === 0
  ).length
  const renameKeysSelectedWorkshift =
    selectedWorkshift !== null
      ? Object.keys(selectedWorkshift).reduce((acc, key) => {
          const newKey = renameMap[key] || key
          acc[newKey] = selectedWorkshift[key]
          return acc
        }, {})
      : {}

  const draftInvoiceValues = invoiceValues(
    invoiceFormValues,
    invoiceRowDefaultValues,
    renameKeysSelectedWorkshift
  )

  React.useEffect(() => {
    if (saveDraftInvoiceSuccess) {
      setSelectedWorkshift(null)
      getBillableHourUser()
    }
  }, [saveDraftInvoiceSuccess])

  React.useEffect(() => {
    const selectedId = (selectedCheckbox || []).map(
      (item) => item.workshift_itemid
    )
    const itemExists = data?.workshifts.filter((item) =>
      selectedId.includes(item.workshift_itemid)
    )

    // only expand if at least one item is selected
    if (selectedAllCheckbox && itemExists.length > 0) {
      setExpand(true)
    }
  }, [selectedAllCheckbox, data?.workshifts])

  return (
    <Translation>
      {(t) => {
        return (
          <>
            <TableRow
              style={{
                background: index % 2 ? 'white' : '#ebf9fa',
                cursor: 'pointer'
              }}
              onClick={() => {
                handleExpandClick()
              }}
            >
              <TableCell
                component="th"
                scope="row"
                className={classes.tablecell}
              >
                {employer_name}{' '}
                {totalNewWorkshifts > 0 && (
                  <span style={{ color: '#F67131' }}>
                    ({totalNewWorkshifts} {t('workshift.new')})
                  </span>
                )}
              </TableCell>
              <TableCell
                component="th"
                scope="row"
                className={classes.tablecell}
              >
                <div className="pull-right">
                  <IconButton aria-label="expand row" size="small">
                    {expand ? (
                      <KeyboardArrowUp fontSize="large" />
                    ) : (
                      <KeyboardArrowDown fontSize="large" />
                    )}
                  </IconButton>
                </div>
              </TableCell>
            </TableRow>
            {expand ? (
              <>
                <TableRow>
                  <TableCell className={classes.tablecell} colSpan={2}>
                    <div>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell className={classes.tablecell}>
                              <b>{t('workshift.col1')}</b>
                            </TableCell>
                            <TableCell className={classes.tablecell}>
                              <b>{t('workshift.col3')}</b>
                            </TableCell>
                            <TableCell className={classes.tablecell}>
                              <b>{t('workshift.col4')}</b>
                            </TableCell>
                            <TableCell className={classes.tablecell}>
                              <b>{t('workshift.col8')}</b>
                            </TableCell>
                            <TableCell
                              className={classes.tablecell}
                            ></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {workshiftRows.map((row) => {
                            const newNotification =
                              row.is_workshift_viewed === 0 &&
                              row.workshift_status_entrepreneur === 0

                            const isSelected = selectedCheckbox.some(
                              (id) =>
                                id.workshift_itemid === row.workshift_itemid
                            )
                            return (
                              <TableRow key={row.workshift_itemid}>
                                <TableCell className={classes.tablecell}>
                                  <u
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => {
                                      setSelectedWorkshift(row),
                                        newNotification &&
                                          updateViewWorkshift(
                                            row.workshift_itemid
                                          )
                                    }}
                                  >
                                    {row.task_description}
                                  </u>
                                </TableCell>
                                <TableCell className={classes.tablecell}>
                                  {moment(row?.workshift_date).format(
                                    'DD.MM.YYYY'
                                  )}
                                </TableCell>
                                <TableCell className={classes.tablecell}>
                                  {formatTime(
                                    row?.workshift_status === 3
                                      ? row?.actualworkshift_starttime
                                      : row?.workshift_start_time
                                  ) +
                                    ' - ' +
                                    formatTime(
                                      row?.workshift_status === 3
                                        ? row?.actualworkshift_endtime
                                        : row?.workshift_endtime
                                    )}
                                  {row?.workshift_status_entrepreneur === 2 &&
                                    (row?.actualworkshift_starttime !==
                                      row?.workshift_start_time ||
                                      row?.actualworkshift_endtime !==
                                        row?.workshift_endtime) && (
                                      <>
                                        <br />
                                        <span style={{ color: '#F67131' }}>
                                          (
                                          {formatTime(
                                            row?.actualworkshift_starttime
                                          ) +
                                            ' - ' +
                                            formatTime(
                                              row?.actualworkshift_endtime
                                            )}
                                          )
                                        </span>
                                      </>
                                    )}
                                </TableCell>
                                <TableCell className={classes.tablecell}>
                                  {convertIntToState_ws(
                                    row.workshift_status_entrepreneur
                                  )}
                                  {newNotification ? (
                                    <span
                                      style={{
                                        fontSize: '20px',
                                        color: '#F67131'
                                      }}
                                    >
                                      {' '}
                                      •
                                    </span>
                                  ) : null}
                                </TableCell>
                                <TableCell className={classes.tablecell}>
                                  <div className="pull-right">
                                    <IconButton
                                      aria-label="expand row"
                                      size="small"
                                      onClick={() => {
                                        pinWorkShift(row.workshift_itemid)
                                      }}
                                      style={
                                        row.pinned_workshift_user
                                          ? { color: '#F67131' }
                                          : null
                                      }
                                    >
                                      <PushPinIcon />
                                    </IconButton>
                                    <Checkbox
                                      icon={
                                        <CheckBoxOutlineBlankIcon fontSize="large" />
                                      }
                                      checkedIcon={
                                        <CheckBoxIcon
                                          fontSize="large"
                                          style={{ fill: '#F67131' }}
                                        />
                                      }
                                      disabled={
                                        row.workshift_status_entrepreneur !== 0
                                      }
                                      checked={isSelected}
                                      onChange={() => {
                                        handleSelectCheckbox(
                                          isSelected,
                                          row.workshift_id,
                                          row.workshift_itemid,
                                          row.offershift_to,
                                          row.workshift_status_entrepreneur
                                        )
                                      }}
                                    />
                                  </div>
                                </TableCell>
                              </TableRow>
                            )
                          })}
                        </TableBody>
                      </Table>
                    </div>
                  </TableCell>
                </TableRow>
                {/* Selected workshift details */}
                <Dialog
                  open={selectedWorkshift !== null}
                  onClose={() => setSelectedWorkshift(null)}
                  fullWidth
                  maxWidth="md"
                >
                  <CloseIcon
                    fontSize="large"
                    onClick={() => setSelectedWorkshift(null)}
                  />
                  <DialogTitle id="alert-dialog-title">
                    <div
                      style={{
                        textAlign: 'center',
                        color: '#000000',
                        fontSize: '15px'
                      }}
                    >
                      {t('workshift.dialogTitle2')}
                    </div>
                  </DialogTitle>
                  <DialogContent>
                    <div>
                      <WorkShiftDetails
                        classes={classes}
                        t={t}
                        selectedWorkshift={selectedWorkshift}
                        task_description={selectedWorkshift?.task_description}
                        company_name={selectedWorkshift?.company_name}
                        workshift_date={moment(
                          selectedWorkshift?.workshift_date
                        ).format('DD.MM.YYYY')}
                        working_hours={
                          selectedWorkshift !== null &&
                          formatTime(selectedWorkshift?.workshift_start_time) +
                            ' - ' +
                            formatTime(selectedWorkshift?.workshift_endtime)
                        }
                        location={selectedWorkshift?.location}
                        workshift_lastdate={moment(
                          selectedWorkshift?.workshift_workshift_lastdatedate
                        ).format('DD.MM.YYYY')}
                        workshift_status_entrepreneur={
                          selectedWorkshift?.workshift_status_entrepreneur
                        }
                        additional_info={selectedWorkshift?.additional_info}
                        workshift_start_time={
                          selectedWorkshift?.workshift_start_time
                        }
                        workshift_endtime={selectedWorkshift?.workshift_endtime}
                        setSelectedWorkshift={setSelectedWorkshift}
                        actualworkshift_starttime={
                          selectedWorkshift?.actualworkshift_starttime
                        }
                        actualworkshift_endtime={
                          selectedWorkshift?.actualworkshift_endtime
                        }
                        workshift_additional_comments={
                          selectedWorkshift?.workshift_additional_comments ===
                          'As scheduled'
                            ? ''
                            : selectedWorkshift?.workshift_additional_comments
                        }
                        workshift_remarks={
                          selectedWorkshift?.workshift_remarks !== null &&
                          selectedWorkshift?.workshift_remarks !== undefined
                            ? JSON.parse(selectedWorkshift?.workshift_remarks)
                            : null
                        }
                      />
                    </div>
                  </DialogContent>
                  <DialogActions style={{ padding: '8px 24px' }}>
                    {selectedWorkshift?.workshift_status_entrepreneur === 0 && (
                      <div
                        className="pull-right"
                        style={{ paddingRight: '16px' }}
                      >
                        <Button
                          variant="outlined"
                          onClick={() => {
                            updateUserWorkshift([selectedWorkshift], 4) // Reject workshift
                            setSelectedWorkshift(null)
                          }}
                          disabled={disableBtn}
                        >
                          {t('workshift.btn2')}
                        </Button>
                        <Button
                          variant="contained"
                          onClick={() => {
                            setShowAcceptWarn(true)
                          }}
                          disabled={disableBtn}
                        >
                          {t('workshift.btn3')}
                        </Button>
                      </div>
                    )}
                    {selectedWorkshift?.workshift_status_entrepreneur === 3 &&
                    (selectedWorkshift?.salary_model === 'Hourly rate' ||
                      selectedWorkshift?.salary_model === 'Commission') ? (
                      invoice_id === null ? (
                        <div className="pull-right">
                          <Button
                            variant="contained"
                            onClick={() => {
                              saveInvoiceDraft(draftInvoiceValues)
                            }}
                          >
                            {t('application.btn8')}
                          </Button>
                        </div>
                      ) : selectedWorkshift?.status === 0 ? (
                        <div className="pull-right">
                          <Link to="/dashboard/invoice">
                            <Button
                              variant="contained"
                              onClick={() => {
                                handleEditInvoice(invoice_id)
                                setSelectedWorkshift(null)
                              }}
                            >
                              {t('application.btn9')}
                            </Button>
                          </Link>
                        </div>
                      ) : (
                        <div className="pull-right">
                          <b>
                            {t('application.invoiceStatusInfo') +
                              convertIntToState(selectedWorkshift?.status)}
                          </b>
                        </div>
                      )
                    ) : selectedWorkshift?.workshift_status_entrepreneur ===
                        3 &&
                      selectedWorkshift?.salary_model === 'Contract price' ? (
                      <i>{t('workshift.note1')}</i>
                    ) : selectedWorkshift?.workshift_status_entrepreneur ===
                        3 &&
                      selectedWorkshift?.salary_model === 'Unit price' ? (
                      <i>{t('workshift.note2')}</i>
                    ) : null}
                  </DialogActions>
                </Dialog>
              </>
            ) : null}
            <Dialog
              open={showAcceptWarn}
              onClose={() => {
                setShowAcceptWarn(false)
              }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                <span style={{ fontSize: '20px' }}>
                  {t('workshift.dialogTitle1')}
                </span>
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <span style={{ fontSize: '14px' }}>
                    {t('workshift.dialogContent1')}
                  </span>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <div className="pull-right">
                  <Button
                    variant="outlined"
                    className={classes.dialogButton}
                    onClick={() => {
                      setShowAcceptWarn(false)
                    }}
                  >
                    {t('workshift.btn4')}
                  </Button>
                  <Button
                    variant="contained"
                    className={classes.dialogButton}
                    onClick={() => {
                      updateUserWorkshift([selectedWorkshift], 0) // Accept workshift
                      setShowAcceptWarn(false)
                      setSelectedWorkshift(null)
                    }}
                  >
                    {t('workshift.btn3')}
                  </Button>
                </div>
              </DialogActions>
            </Dialog>
          </>
        )
      }}
    </Translation>
  )
}

// Rename keys
const renameMap = {
  workshift_id: 'workshift_id',
  workshift_itemid: 'workshift_itemid',
  company_name: 'company_name',
  email: 'email',
  offershift_to: 'offershift_to',
  workshift_lastdate: 'workshift_lastdate', //
  task_description: 'job_title',
  additional_info: 'additional_info',
  workshift_date: 'assignment_begins', // Just rename as assignment_begins for matching function data
  workshift_start_time: 'workshift_start_time',
  workshift_endtime: 'workshift_endtime',
  workshift_status_entrepreneur: 'workshift_status_entrepreneur',
  workshift_status: 'workshift_status',
  location: 'location',
  entrepreneurs_rating: 'entrepreneurs_rating',
  actualhours_billed: 'actualhours_billed',
  workshift_additional_comments: 'workshift_additional_comments',
  time_spent: 'time_spent',
  actualworkshift_starttime: 'actualworkshift_starttime',
  actualworkshift_endtime: 'actualworkshift_endtime',
  pinned_workshift_user: 'pinned_workshift_user',
  created_date: 'created_date',
  amount: 'amount',
  workshift_remarks: 'workshift_remarks'
}

export default withStyles(styles)(WorkshiftUserRow)
